import axios from "axios";

const api = axios.create({
  baseURL: "https://api.whisperingsand.lv/api/v1",
});

export const getNews = () => api.get("/news");
export const getNewsById = (id: string) => api.get(`/news/${id}`);

export const getDogs = () => api.get("/dogs");
export const getDogById = (id: string) => api.get(`/dogs/${id}`);

export const getLitters = () => api.get("/litters");
export const getLitterById = (id: string) => api.get(`/litter/${id}`);

export const getPuppyById = (id: string) => api.get(`/puppies/${id}`);

export const getAvailablePuppies = () => api.get("/puppies/available");

export const getSettings = () => api.get("/settings");

export const getPedigree = (id: string) => api.get(`/pedigree/${id}`);
